import { useFormContext } from "react-hook-form";
import { FormField, FormControl, FormMessage } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ReactNode } from "react";

interface FormSelectProps {
	name: string;
	label: string;
	options: { value: string; label: string }[];
	placeholder?: string;
	required?: boolean;
	disabled?: boolean;
	extraLabelElement?: ReactNode;
}

export const FormSelect = ({
	name,
	label,
	options,
	placeholder = "Select an option",
	required = false,
	disabled = false,
	extraLabelElement,
}: FormSelectProps) => {
	const { control } = useFormContext();

	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<div className="grid gap-2">
					<div className="flex items-center">
						<Label htmlFor={name}>
							{label}
							{required && <span className="text-red-500">*</span>}
						</Label>
						{extraLabelElement && <div className="ml-auto">{extraLabelElement}</div>}
					</div>
					<FormControl>
						<Select onValueChange={field.onChange} value={field.value} disabled={disabled}>
							<SelectTrigger>
								<SelectValue placeholder={placeholder} />
							</SelectTrigger>
							<SelectContent>
								{options.map(option => (
									<SelectItem key={option.value} value={option.value}>
										{option.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</FormControl>
					<FormMessage />
				</div>
			)}
		/>
	);
};
